// Typelizer digest fb20f9bebb7710d61e76c1e5440f73ea
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /accountant/clients/:client_id/ledger_accounts */
  create: (
    params: { clientId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/accountant/clients/:client_id/ledger_accounts', params, options),
    method: 'post',
  }),

  /** PATCH /accountant/clients/:client_id/ledger_accounts/:id */
  update: (
    params: { clientId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/accountant/clients/:client_id/ledger_accounts/:id', params, options),
    method: 'patch',
  }),
}
